export default __webpack_public_path__ + "static/media/promo3.79bb0bed.webp";